/** Renders one static tier card for email image capture: /preview/tier-art?tier=gold */
import { useSearchParams } from 'react-router-dom';
import { ShowcaseSlide } from '../../components/TierShowcase';

export default function TierEmailArt() {
  const [params] = useSearchParams();
  const tier = params.get('tier') || 'gold';
  return (
    <div style={{ background: '#FFFFFF', padding: 16, width: 528 }} data-testid="tier-email-art">
      <style>{'*{animation-play-state:paused!important;animation-delay:-2.5s!important}.am-twinkle{opacity:1!important}'}</style>
      <ShowcaseSlide tierKey={tier} status="current" isModern />
    </div>
  );
}
